import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive } from 'vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { mapsEnum, statusEnum } from './enum'
import { updateMapConfig } from '@/api/systemSetting/index'
import type { MapListItem, MapListParams } from '@/typings/api/systemSetting'


const __default__ = { name: 'ModalForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['fetch'],
  setup(__props, { expose: __expose, emit: __emit }) {

const initDefaultData = () => ({ mapType: 0, status: 0, mapAndroidKey: '', mapIosKey: '', mapWebKey: '' })
const formRef = ref()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const dataForm = reactive<MapListParams>(initDefaultData())
const formRules = reactive({
  input: [{ required: true, message: '请输入' }],
  select: [{ required: true, message: '请选择' }]
})
const emit = __emit

const mapList = ref<MapListItem[]>([])
const currentIndex = ref<number>(0)
// 弹窗标题
const modalTitle = '编辑地图配置'
const init = (rows: MapListItem, list: MapListItem[]) => {
  mapList.value = list.map((item) => {
    const { mapType, status, mapAndroidKey, mapIosKey, mapWebKey } = item
    return { mapType, status, mapAndroidKey, mapIosKey, mapWebKey }
  })
  currentIndex.value = list.findIndex((item) => item.mapType === rows.mapType)

  const { mapType, status, mapAndroidKey, mapIosKey, mapWebKey } = rows
  Object.assign(dataForm, { mapType, status, mapAndroidKey, mapIosKey, mapWebKey })
  visible.value = true
}

const handleOk = async () => {
  try {
    await formRef.value?.validate()
    loading.value = true
    const params = mapList.value.slice() // 深拷贝
    params.splice(currentIndex.value, 1) // 删除当前项
    params.splice(currentIndex.value, 0, dataForm) // 插入当前项
    await updateMapConfig(params)
    DcMessage.success('操作成功！')
    emit('fetch')
    handleCancel()
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}
const handleCancel = () => {
  formRef.value?.resetFields()
  visible.value = false
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
    width: 600,
    title: modalTitle,
    confirmLoading: loading.value,
    destroyOnClose: "",
    onOk: handleOk,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        "wrapper-col": { span: 24 },
        ref_key: "formRef",
        ref: formRef,
        model: dataForm
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "地图类型",
            name: "mapType",
            rules: formRules.select
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: dataForm.mapType,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.mapType) = $event)),
                options: _unref(mapsEnum),
                disabled: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            label: "地图状态",
            name: "status",
            rules: formRules.select
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: dataForm.status,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.status) = $event)),
                fieldNames: { label: 'name' },
                options: _unref(statusEnum),
                disabled: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            label: "Android Key",
            name: "mapAndroidKey"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosInput, {
                value: dataForm.mapAndroidKey,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.mapAndroidKey) = $event)),
                placeholder: "请输入",
                maxlength: 100
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "IOS Key",
            name: "mapIosKey"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosInput, {
                value: dataForm.mapIosKey,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.mapIosKey) = $event)),
                placeholder: "请输入",
                maxlength: 100
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Web Key",
            name: "mapWebKey"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosInput, {
                value: dataForm.mapWebKey,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.mapWebKey) = $event)),
                placeholder: "请输入",
                maxlength: 100
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "confirmLoading"]))
}
}

})